export default {
  //路由語言
  'home.title': '首頁',
  'detail.title': '詳情',
  'shareDetail.title': '分享頁',
  'filter.title': '篩選',
  'special.title': '專題',
  'search.title': '搜索',
  'activity.title': '活動',

  //首頁語言
  'home.page.more': '更多',
  'home.page.hot': '熱點推薦',
  'home.page.good': '最熱最新',

  //搜索頁語言
  'search.page.cancel': '取消',
  'search.page.placeholder': '請輸入片名、主演或導演',
  'search.page.searchToast1': '未搜索到相關內容',
  'search.page.searchToast2': '請換個詞再試試吧',
  'search.page.searchhistory': '搜索歷史',
  'search.page.hotSearch': '熱門搜索',
  'filter.page.failToast': '無篩選結果',
  'search.page.address': '地區',
  'search.page.act': '主演',
  'search.page.from': '來源',
  'search.page.year': '年份',
  'search.page.mangguo': '芒果TV',
  'search.page.hmvod': 'HMVOD',

  //詳情語言
  'detail.page.share': '分享',
  'detail.page.summary': '簡介  ',
  'detail.page.selection': '選集',
  'detail.page.selections': '全部選集',
  'detail.page.recommend': '爲您推薦',
  'detail.page.err': '遇到問題',
  'detail.page.3001': '本片需要購買觀看',
  'datail.page.orderButton': '立即訂購',
  'detail.page.watchingHorror': '看正片',
  'detail.page.scanQR': '請掃描二維碼下載客戶端觀看',
  'detail.page.Android': '安卓下載',
  'detail.page.IOS': 'IOS下載',
  'detail.page.next': '播放下一個',
  'detail.page.age': '適齡年齡',
  'detail.page.Playability': '輸入設備',
  'detail.page.Players': '玩家數',
  'detail.page.Availability': '可玩平臺',
  'detail.page.ReadMore': '查看更多',
  'detail.page.PlayGame': '開始遊戲',

  //播放器提示語言
  'video.page.vodFailToast': '該資產無法播放，換個資產試試看吧',

  // 收藏
  'collect.page.myCollect': '我的收藏',
  'collect.page.view': '最近觀看',
  'collect.page.viewRecord': '觀看記錄',
  'collect.page.noView': '暫無最近觀看内容',
  'collect.page.noCollect': '暫無收藏記錄',
  'collect.page.clear': '清空記錄',
  'collect.page.collect': '收藏',
  'collect.page.cancelCollect': '取消收藏',
  'collect.page.movie': '電影',
  'collect.page.series': '電視劇',
  'collect.page.news': '資訊',
  'collect.page.column': '綜合類型',
  'collect.page.category': '專題',
  'collect.page.today': '今日',
  'collect.page.yesterday': '昨日',
  'collect.page.beforeYesterday': '前日',
  'collect.page.earlier': '更早',
  'collect.page.part': '部',
  'collect.page.clearView': '確認清空最近觀看記錄嗎',
  'collect.page.clearCollect': '確認清空收藏記錄嗎',
  'collect.page.clearSuccess': '記錄清除成功',
  'collect.page.oneClearSuccess': '已取消',
  'collect.page.oneCollectSuccess': '已收藏',
  'collect.page.CollectSpecial': '收藏專題',

  // 个人中心
  'profile.page.profile': '個人中心',
  'profile.page.cut': '切換賬號',
  'profile.page.login': '登出賬號',
  'profile.page.logout': '退出登錄',
  'profile.page.bill': '賬單',
  'profile.page.equity': '權益',
  'profile.page.download': '下載 CTM Home Media 應用程式',
  'profile.page.lang': '語言切換',
  'profile.page.patriarch': '家長管制',
  'profile.page.type': '類別',
  'profile.page.title': '名稱',
  'profile.page.time': '訂單時間',
  'profile.page.payTime': '購買時間',
  'profile.page.validTime': '有效期',
  'profile.page.price': '購買價格',
  'profile.page.none': '暫無數據',
  'profile.page.open': '（已開啓)',
  'profile.page.closed': '(已關閉)',
  'profile.page.mumber': '會員',
  'profile.page.ticket': '電影券',
  'profile.page.Tip1': '注：月費支付的會員有效期直到取消服務爲止',

  // 登陸
  'login.page.phone': '手機號碼登錄/註冊',
  'login.page.verify': '去驗證',
  'login.page.qrcode': '請使用 CTM Home Media 手機應用程式掃碼登錄',
  'login.page.back': '返回',
  'login.page.sureLogin': '確認登錄',
  'login.page.verification': '請輸入驗證碼完成登錄/註冊',
  'login.page.check': '安全校驗',
  'login.page.answer': '請填寫正確答案以完成校驗',
  'login.page.sure': '確認',
  'login.page.next': '換一張',
  'login.page.require': '重新驗證',
  'login.page.please': '請輸入正確的手機號',
  'login.page.loginSuccess': '登錄成功',
  'login.page.pleaseCode': '請輸入驗證碼',
  'login.page.pleaseTrueCode': '請輸入正確驗證碼',
  'login.page.pleaseImgVerify': '請輸入圖片驗證碼結果',
  'login.page.pleaseTrueImgVerify': '請輸入正確的圖片驗證碼結果',
  'login.page.openordownload': '下載/打開',
  'login.page.clickRight': '請點擊右上角，選擇在瀏覽器中打開鏈接',

  // 订购
  'order.page.QRpayType': '掃碼支付平台',
  'order.page.QRtips':
    '掃碼支付提示：1.成功付款後服務隨即生效；2.首月服務計劃有效期為30日',
  'order.page.QRpay': '二維碼支付',
  'order.page.paySuccess': '訂購成功',
  'order.page.paySuccess1': '成功，您已完成會員權益的訂購',
  'order.page.paySuccess2': '尊敬的會員，您好',
  'order.page.paySuccess3':
    ' 您可在“我的”權益中心查看您訂購的權益，享受會員服務過程中如有問題可聯繫客服1000',
  'order.page.selfRecovery': '後自動返回',
  'order.page.payfaile1': '未能成功購買',
  'order.page.payfaile2': '抱歉，訂購過程中遇到問題，訂購失敗',
  'order.page.warnCode': '錯誤碼',
  'order.page.payfaile3': '1. 請您選擇其他節目或重新刷新再次嘗試',
  'order.page.payfaile4': ' 2. 如以上方法均無法解決，請撥打 1000 進行咨詢。',
  'order.page.payfaile3005':
    '您的會員權益正在處理，如有需要，可聯繫客服電話1000',
  'order.page.payfaile3006': ' 您的會員權益正在處理中，請稍候',
  'order.page.close': '關閉',
  'order.page.getCode': '獲取驗證碼',
  'order.page.getCodeAgain': '重新獲取驗證碼',
  'order.page.payVerify': '支付驗證',
  'order.page.billPay': '流動賬單支付',
  'order.page.payCode': '支付賬號',
  'order.page.order': '訂購',
  'order.page.pleaseDuCode': '請輸入DU賬號',
  'order.page.pleaseID': '請輸入身份ID',
  'order.page.InternetOrder': '互聯網賬單支付',
  'order.page.pleaseDu': '請輸入服務DU',
  'order.page.ID': '身份ID',
  'order.page.ordering': '訂購中，請稍後',
  'order.page.WXPC': '工银澳门-微信PC',
  'order.page.developing': '開發中',
  'order.page.purchaseType': '選擇購買類型',
  'order.page.paymentType': '請選擇支付方式',
  'order.page.viewService': '查看服務條款與細則',
  'order.page.Tip1': '購買即同意上述《服務條款與細則》',
  'order.page.Tip2': '本服務之條款及細則（「本條款及細則」）',

  // 首页语言
  'home.page.lodin': '您已登錄',
  'home.page.day': '天',
  //  Toast
  'toast.page.processed': '您所申請的服務正在處理中，請稍後再試',

  // 筛选
  'filter.page.all': '全部',
  'filter.page.open': '最近打开',
  'filter.page.collect': '我的收藏',

  // 家长管制
  'parent.page.set': '設置家長管制',
  'parent.page.num': '賬號',
  'parent.page.code': '手機驗證碼',
  'parent.page.setPassword': '設置家長管制密碼',
  'parent.page.pleasePIN': '請輸入密碼',
  'parent.page.getCode': '獲取驗證碼',
  'parent.page.wrongPassword': '密碼錯誤',
  'parent.page.notice': '注意',
  'parent.page.Tip1':
    '本物品内容可能令人反感;不可将本物品派发、传阅、出售、出租、交给或出借予年龄未满18岁的人士或将本物品向该等人士出示、播放或放映您需要開啟管制才能繼續觀看該内容。',
  'parent.page.verify': '驗證',
  'parent.page.close': '關閉家長管制',
  'parent.page.open': '開啓家長管制',
  'parent.page.onmsg': '家长管制已開啓',
  'parent.page.offmsg': '家长管制已關閉',
  'parent.page.pleaseOpen': '請先開啓家长管制',
  'parent.page.changePassword': '修改密碼',

  // HMOVD
  'hmovd.page.member': '會員無限睇',
  'hmovd.page.ticket': '電影券',
  'hmovd.page.use': '本次使用',
  'hmovd.page.have': '拥有',
  'hmovd.page.piece': '張',
  'hmovd.page.validity': '有效期',
  'hmovd.page.Tip1': '觀影劵不足，需要購買觀影劵',
  'hmovd.page.Tip2': '購買使用後 48 小时内有效，可重看',
  'hmovd.page.Tip3': '所有额外赠送觀影劵使用期限到取消服务爲止',
  'hmovd.page.Tip4': '支付成功，請在48小時内觀看',
  'hmovd.page.exchange': '立即兌換',
  'hmovd.page.buy': '立即購買',
  'hmovd.page.surplus': '電影券剩餘',
  'hmovd.page.please': '請使用觀影劵觀看內容',
  'hmovd.page.need': '需要購買後才可觀看',
  'hmovd.page.look': '電影券觀看',
  'hmovd.page.purchase': '購買',

  // live
  'live.page.allLive': '全部直播',
  'live.page.living': '直播中',
  'live.page.purchase': '付費',
  'live.page.otherLive': '其他直播',
  'live.page.tryWill': '試看將在',
  'live.page.end': '分鐘后結束，完整版請',
  'live.page.pay': '購買本片',
  'live.page.needPay': '本場直播需要付費觀看',
  'live.page.payLook': '購買觀看',
  'live.page.from': '距',
  'live.page.liveAnd': '直播還有',
  'live.page.hours': '時',
  'live.page.minutes': '分',
  'live.page.seconds': '秒',
  'live.page.liveEnd': '直播已結束',
  'live.page.exitFullscreen': '退出全屏',

  //mytv
  'mytv.page.playNow': '立即播放',
  'mytv.page.firstTimeWatch': '首次觀看myTV內容需添加Email帳號',
  'mytv.page.account': '帳號',
  'mytv.page.emailAddress': 'Email地址',
  'mytv.page.phoneNumberVerification': '流動電話驗證碼',
  'mytv.page.retryAfter': '後重新獲取',
  'mytv.page.getVerificationCode': '獲取驗證碼',
  'mytv.page.emailNotice':
    '注意：Email地址與會員權益相關，一經設置不可自行修改，更換Email帳號有可能影響已購會員權益',
  'mytv.page.confirm': '確認',
  'mytv.page.cancel': '取消',
  'mytv.page.confirmLater': '後可確認',
  'mytv.page.confirmEmailAddress': '確認Email帳號',
  'mytv.page.enterEmailAddress': '您要綁定的Email帳號',
  'mytv.page.emailBindingSuccess': '綁定成功',
  'mytv.page.enterValidEmailAddress': '請輸入正確的Email帳號',
  'mytv.page.enterVerificationCode': '請輸入驗證碼',
  'mytv.page.enterEmailAddressPrompt': '請輸入Email帳號',
  'mytv.page.bindEmail': '添加郵箱地址',
};
